module.exports = __webpack_public_path__ + "static/media/whichThinnerDontMiss.dc1c2c5c.mp3";